import React from 'react'
import PropTypes from 'prop-types';

import  JobApplicationsInternalSingle from './JobApplicationsInternalSingle'

export const JobApplicationsInternal = (props) => {

    const {
        statuses,
        deleteApplication,
        internal
    } = props;

    if (!internal) return '';

    return (
        <section className="applications--my-applications">
            <h4 className="h4">Ongoing applications</h4>
            <p className="p-tag">Keep track of your job applications using the tool below.</p>
            <div className="table--jobs">
                <div className="table__header visible-md-block visible-lg-block">
                    <div className="row">
                        <div className="col-xs-12 col-md-4">
                            <h5 className="h5 header">Position and Salary</h5>
                        </div>
                        <div className="col-xs-12 col-md-2">
                            <h5 className="h5 header">Closing date</h5>
                        </div>
                        <div className="col-xs-12 col-md-5">
                            <h5 className="h5 header">Update application status</h5>
                        </div>
                        <div className="col-xs-12 col-md-1">
                            <h5 className="h5 header">Remove</h5>
                        </div>
                    </div>
                </div>
                <div className="table__body">
                    {
                        internal && internal.length > 0 && internal.map((application, i) => {
                            return <JobApplicationsInternalSingle 
                                application={application}
                                key={i}
                                statuses={statuses}
                                deleteApplication={deleteApplication}
                            />
                        })
                    }
                </div>
            </div>
        </section>
    )
}

JobApplicationsInternal.propTypes = {
    deleteApplication: PropTypes.func,
    statuses: PropTypes.array,
    internal: PropTypes.array,
};



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobApplicationsInternal.js